import {
  FORMAT_D3_TIME_WITH_SECONDS,
  ONE_DAY_OF_MS,
  FORMAT_D3_DATE,
  ONE_MINUTE_OF_MS,
  FORMAT_D3_DATE_TIME,
} from "../../../utils/timeUtils";

export const tickGroups = (visisbleDomainMs: number) => {
  let tickFormat = FORMAT_D3_TIME_WITH_SECONDS;
  // change the format at different scales (> 3 min, > 2 days)
  if (visisbleDomainMs > 2 * ONE_DAY_OF_MS) {
    tickFormat = FORMAT_D3_DATE;
  } else if (visisbleDomainMs > 3 * ONE_MINUTE_OF_MS) {
    tickFormat = FORMAT_D3_DATE_TIME;
  }

  return [
    {
      nTicks: 6,
      tickFormat: "",
      classNames: "minorTicks",
    },
    {
      nTicks: 3,
      tickFormat,
      classNames: "majorTicks",
    },
  ];
};
